module.exports = __webpack_public_path__ + "static/Sophie_Green-3d7e0575ae76cafb35cb550e6ff0c8d6.webp";